import { render, staticRenderFns } from "./CreateParameterAction.vue?vue&type=template&id=2597211b"
import script from "./CreateParameterAction.vue?vue&type=script&lang=js"
export * from "./CreateParameterAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports